export const CONTACT_TOPICS: { value: string; label: string }[] = [
  { value: 'general', label: 'General inquiry' },
  { value: 'bug', label: 'Bug report' },
  { value: 'feature', label: 'Feature request' },
  { value: 'account', label: 'Account / subscription' },
  { value: 'content', label: 'Content / questions' },
  { value: 'other', label: 'Other' },
];
